import ABP from "@/components/ui/icons/stacks/abp"
import Adonis from "@/components/ui/icons/stacks/adonis"
import Alpine from "@/components/ui/icons/stacks/alpine"
import AmazonLightsail from "@/components/ui/icons/stacks/amazon-lightsail"
import AngularJS from "@/components/ui/icons/stacks/angularjs"
import AntDesign from "@/components/ui/icons/stacks/ant-design"
import Apollo from "@/components/ui/icons/stacks/apollo"
import AspNet from "@/components/ui/icons/stacks/aspnet"
import Astro from "@/components/ui/icons/stacks/astro"
import AWSAmplify from "@/components/ui/icons/stacks/aws-amplify"
import Blazor from "@/components/ui/icons/stacks/blazor"
import Boostrap from "@/components/ui/icons/stacks/boostrap"
import BainTree from "@/components/ui/icons/stacks/braintree"
import Brevo from "@/components/ui/icons/stacks/brevo"
import Bulma from "@/components/ui/icons/stacks/bulma"
import ChakraUI from "@/components/ui/icons/stacks/chakraui"
import Cloudflare from "@/components/ui/icons/stacks/cloudflare"
import Crisp from "@/components/ui/icons/stacks/crisp"
import DaisyUI from "@/components/ui/icons/stacks/daisyui"
import Django from "@/components/ui/icons/stacks/django"
import Docker from "@/components/ui/icons/stacks/docker"
import DotNet from "@/components/ui/icons/stacks/dot-net"
import Drizzle from "@/components/ui/icons/stacks/drizzle"
import DynamoDB from "@/components/ui/icons/stacks/dynamodb"
import Elixir from "@/components/ui/icons/stacks/elixir"
import Expo from "@/components/ui/icons/stacks/expo"
import Express from "@/components/ui/icons/stacks/express"
import FastSpring from "@/components/ui/icons/stacks/fastspring"
import Filament from "@/components/ui/icons/stacks/filmanet"
import Firebase from "@/components/ui/icons/stacks/firebase"
import Flask from "@/components/ui/icons/stacks/flask"
import Flutter from "@/components/ui/icons/stacks/flutter"
import FlyIO from "@/components/ui/icons/stacks/flyio"
import Formik from "@/components/ui/icons/stacks/formik"
import GOLang from "@/components/ui/icons/stacks/go-lang"
import GoogleAnalytics from "@/components/ui/icons/stacks/google-analytics"
import Graphql from "@/components/ui/icons/stacks/graphql"
import HeadlessUI from "@/components/ui/icons/stacks/headless-ui"
import InteriaJS from "@/components/ui/icons/stacks/interiajs"
import Javascript from "@/components/ui/icons/stacks/javascript"
import Jest from "@/components/ui/icons/stacks/jest"
import Jotai from "@/components/ui/icons/stacks/jotai"
import Jquery from "@/components/ui/icons/stacks/jquery"
import Knex from "@/components/ui/icons/stacks/knex"
import Laravel from "@/components/ui/icons/stacks/laravel"
import LemonSqueezy from "@/components/ui/icons/stacks/lemonsqueezy"
import Livewire from "@/components/ui/icons/stacks/livewire"
import Lodash from "@/components/ui/icons/stacks/lodash"
import Loops from "@/components/ui/icons/stacks/loops"
import MailChimp from "@/components/ui/icons/stacks/mailchimp"
import MailerSend from "@/components/ui/icons/stacks/mailer-send"
import Mailgun from "@/components/ui/icons/stacks/mailgun"
import Mantine from "@/components/ui/icons/stacks/mantine"
import MaterialUI from "@/components/ui/icons/stacks/materialui"
import Metricalp from "@/components/ui/icons/stacks/metricalp"
import MixPanel from "@/components/ui/icons/stacks/mix-panel"
import MongoDB from "@/components/ui/icons/stacks/mongodb"
import MySQL from "@/components/ui/icons/stacks/mysql"
import NestJS from "@/components/ui/icons/stacks/nestjs"
import Netlify from "@/components/ui/icons/stacks/netlify"
import NextAuth from "@/components/ui/icons/stacks/next-auth"
import NextJS from "@/components/ui/icons/stacks/nextjs"
import Nginx from "@/components/ui/icons/stacks/nginx"
import NodeMailer from "@/components/ui/icons/stacks/node-mailer"
import NodeJS from "@/components/ui/icons/stacks/nodejs"
import NuxtJS from "@/components/ui/icons/stacks/nuxtjs"
import NX from "@/components/ui/icons/stacks/nx"
import Paddle from "@/components/ui/icons/stacks/paddle"
import Paypal from "@/components/ui/icons/stacks/paypal"
import Phoenix from "@/components/ui/icons/stacks/phoenix"
import PHP from "@/components/ui/icons/stacks/php"
import PlanetScale from "@/components/ui/icons/stacks/planetscale"
import Plausible from "@/components/ui/icons/stacks/plausible"
import PostMark from "@/components/ui/icons/stacks/post-mark"
import PostGresql from "@/components/ui/icons/stacks/postgresql"
import Posthog from "@/components/ui/icons/stacks/posthog"
import Prisma from "@/components/ui/icons/stacks/prisma"
import PocketBase from "@/components/ui/icons/stacks/procket-base"
import Python from "@/components/ui/icons/stacks/python"
import RadixUI from "@/components/ui/icons/stacks/radixui"
import ReactBootstrap from "@/components/ui/icons/stacks/react-bootstrap"
import ReactNative from "@/components/ui/icons/stacks/react-native"
import ReactQuery from "@/components/ui/icons/stacks/react-query"
import ReactJS from "@/components/ui/icons/stacks/reactjs"
import RecoilJS from "@/components/ui/icons/stacks/recoiljs"
import Redis from "@/components/ui/icons/stacks/redis"
import Redux from "@/components/ui/icons/stacks/redux"
import RedWoodJS from "@/components/ui/icons/stacks/redwoodjs"
import Reflex from "@/components/ui/icons/stacks/reflex"
import Remix from "@/components/ui/icons/stacks/remix"
import Resend from "@/components/ui/icons/stacks/resend"
import RevenueCat from "@/components/ui/icons/stacks/revenuecat"
import RubyOnRails from "@/components/ui/icons/stacks/rubyonrails"
import SCSS from "@/components/ui/icons/stacks/scss"
import Sentry from "@/components/ui/icons/stacks/sentry"
import Serverless from "@/components/ui/icons/stacks/serverless"
import ShadCN from "@/components/ui/icons/stacks/shadcn"
import SQLLite from "@/components/ui/icons/stacks/sql-lite"
import Stripe from "@/components/ui/icons/stacks/stripe"
import Supabase from "@/components/ui/icons/stacks/supabase"
import SvelteKit from "@/components/ui/icons/stacks/sveltekit"
import SwiftUI from "@/components/ui/icons/stacks/swift-ui"
import Symfony from "@/components/ui/icons/stacks/symfony"
import TailwindCSS from "@/components/ui/icons/stacks/tailwindcss"
import TRPC from "@/components/ui/icons/stacks/trpc"
import TurbineUI from "@/components/ui/icons/stacks/turbineui"
import TurboPack from "@/components/ui/icons/stacks/turbo-pack"
import TurboRepo from "@/components/ui/icons/stacks/turbo-repo"
import Typescript from "@/components/ui/icons/stacks/typescript"
import UpStash from "@/components/ui/icons/stacks/upstash"
import Vercel from "@/components/ui/icons/stacks/vercel"
import Vite from "@/components/ui/icons/stacks/vite"
import VueJS from "@/components/ui/icons/stacks/vuejs"
import WordPress from "@/components/ui/icons/stacks/wordpress"
import Zod from "@/components/ui/icons/stacks/zod"
import Zustand from "@/components/ui/icons/stacks/zustand"

export type Techno = {
  name: string
  icon: any
}

export const technos: Techno[] = [
  {
    name: "ABP",
    icon: ABP,
  },
  {
    name: "AdonisJS",
    icon: Adonis,
  },
  {
    name: "AlpineJS",
    icon: Alpine,
  },
  {
    name: "Angular",
    icon: AngularJS,
  },
  {
    name: "Ant Design",
    icon: AntDesign,
  },
  {
    name: "Apollo GraphQL",
    icon: Apollo,
  },
  {
    name: "ASP.NET",
    icon: AspNet,
  },
  {
    name: "Astro",
    icon: Astro,
  },
  {
    name: "Blazor",
    icon: Blazor,
  },
  {
    name: "Bootstrap",
    icon: Boostrap,
  },
  {
    name: "BainTree",
    icon: BainTree,
  },
  {
    name: "Brevo",
    icon: Brevo,
  },
  {
    name: "Bulma",
    icon: Bulma,
  },
  {
    name: "Chakra UI",
    icon: ChakraUI,
  },
  {
    name: "DaisyUI",
    icon: DaisyUI,
  },
  {
    name: "Django",
    icon: Django,
  },
  {
    name: "Docker",
    icon: Docker,
  },
  {
    name: "DotNet",
    icon: DotNet,
  },
  {
    name: "Drizzle",
    icon: Drizzle,
  },
  {
    name: "DynamoDB",
    icon: DynamoDB,
  },
  {
    name: "Elixir",
    icon: Elixir,
  },
  {
    name: "Express",
    icon: Express,
  },
  {
    name: "Fast Spring",
    icon: FastSpring,
  },
  {
    name: "Firebase",
    icon: Firebase,
  },
  {
    name: "Flask",
    icon: Flask,
  },
  {
    name: "Flutter",
    icon: Flutter,
  },
  {
    name: "Fly.io",
    icon: FlyIO,
  },
  {
    name: "GO Lang",
    icon: GOLang,
  },
  {
    name: "GraphQL",
    icon: Graphql,
  },
  {
    name: "Headless UI",
    icon: HeadlessUI,
  },
  {
    name: "InteriaJS",
    icon: InteriaJS,
  },
  {
    name: "Jquery 💩",
    icon: Jquery,
  },
  {
    name: "Knex",
    icon: Knex,
  },
  {
    name: "LemonSqueezy",
    icon: LemonSqueezy,
  },
  {
    name: "Loops",
    icon: Loops,
  },
  {
    name: "Mantine",
    icon: Mantine,
  },
  {
    name: "Material UI",
    icon: MaterialUI,
  },
  {
    name: "MongoDB",
    icon: MongoDB,
  },
  {
    name: "MySql",
    icon: MySQL,
  },
  {
    name: "NestJS",
    icon: NestJS,
  },
  {
    name: "Netlify",
    icon: Netlify,
  },
  {
    name: "NextAuth",
    icon: NextAuth,
  },
  {
    name: "NextJS",
    icon: NextJS,
  },
  {
    name: "Nginx",
    icon: Nginx,
  },
  {
    name: "NodeJS",
    icon: NodeJS,
  },
  {
    name: "NuxtJS",
    icon: NuxtJS,
  },
  {
    name: "NX",
    icon: NX,
  },
  {
    name: "Paddle",
    icon: Paddle,
  },
  {
    name: "Paypal",
    icon: Paypal,
  },
  {
    name: "Phoenix",
    icon: Phoenix,
  },
  {
    name: "PlanetScale",
    icon: PlanetScale,
  },
  {
    name: "PostgreSQL",
    icon: PostGresql,
  },
  {
    name: "Prisma",
    icon: Prisma,
  },
  {
    name: "Python",
    icon: Python,
  },
  {
    name: "RadixUI",
    icon: RadixUI,
  },
  {
    name: "React Bootstrap",
    icon: ReactBootstrap,
  },
  {
    name: "React Native",
    icon: ReactNative,
  },
  {
    name: "React.JS",
    icon: ReactJS,
  },
  {
    name: "Recoil JS",
    icon: RecoilJS,
  },
  {
    name: "Redis",
    icon: Redis,
  },
  {
    name: "RedwoodJS",
    icon: RedWoodJS,
  },
  {
    name: "Reflex",
    icon: Reflex,
  },
  {
    name: "Remix",
    icon: Remix,
  },
  {
    name: "Resend",
    icon: Resend,
  },
  {
    name: "RevenueCat",
    icon: RevenueCat,
  },
  {
    name: "Ruby on Rails",
    icon: RubyOnRails,
  },
  {
    name: "Serverless",
    icon: Serverless,
  },
  {
    name: "Shadcn",
    icon: ShadCN,
  },
  {
    name: "Stripe",
    icon: Stripe,
  },
  {
    name: "Supabase",
    icon: Supabase,
  },
  {
    name: "Svelte Kit",
    icon: SvelteKit,
  },
  {
    name: "Symfony",
    icon: Symfony,
  },
  {
    name: "TailwindCSS",
    icon: TailwindCSS,
  },
  {
    name: "TRPC",
    icon: TRPC,
  },
  {
    name: "Turbo Pack",
    icon: TurboPack,
  },
  {
    name: "Turbo Repo",
    icon: TurboRepo,
  },
  {
    name: "Typescript",
    icon: Typescript,
  },
  {
    name: "Vercel",
    icon: Vercel,
  },
  {
    name: "Vite",
    icon: Vite,
  },
  {
    name: "Vue.JS",
    icon: VueJS,
  },
  {
    name: "Wordpress",
    icon: WordPress,
  },
  {
    name: "Upstash",
    icon: UpStash,
  },
  {
    name: "SCSS",
    icon: SCSS,
  },
  {
    name: "Redux",
    icon: Redux,
  },
  {
    name: "Jotai",
    icon: Jotai,
  },
  {
    name: "Zustand",
    icon: Zustand,
  },
  {
    name: "Javascript",
    icon: Javascript,
  },
  {
    name: "React Query",
    icon: ReactQuery,
  },
  {
    name: "Formik",
    icon: Formik,
  },
  {
    name: "Zod",
    icon: Zod,
  },
  {
    name: "Lodash",
    icon: Lodash,
  },
  {
    name: "Mailgun",
    icon: Mailgun,
  },
  {
    name: "AWS Amplify",
    icon: AWSAmplify,
  },
  {
    name: "Google Analytics",
    icon: GoogleAnalytics,
  },
  {
    name: "Crisp",
    icon: Crisp,
  },
  {
    name: "Node Mailer",
    icon: NodeMailer,
  },
  {
    name: "Posthog",
    icon: Posthog,
  },
  {
    name: "Plausible",
    icon: Plausible,
  },
  {
    name: "PostMark",
    icon: PostMark,
  },
  {
    name: "Amazon Lightsail",
    icon: AmazonLightsail,
  },
  {
    name: "SQL Lite",
    icon: SQLLite,
  },
  {
    name: "Mailchimp",
    icon: MailChimp,
  },
  {
    name: "Laravel",
    icon: Laravel,
  },
  {
    name: "Livewire",
    icon: Livewire,
  },
  {
    name: "Expo",
    icon: Expo,
  },
  {
    name: "Sentry",
    icon: Sentry,
  },
  {
    name: "Filament",
    icon: Filament,
  },
  {
    name: "Cloudflare",
    icon: Cloudflare,
  },
  {
    name: "MailerSend",
    icon: MailerSend,
  },
  {
    name: "SwiftUI",
    icon: SwiftUI,
  },
  {
    name: "PocketBase",
    icon: PocketBase,
  },
  {
    name: "Mixpanel",
    icon: MixPanel,
  },
  {
    name: "Metricalp",
    icon: Metricalp,
  },
  {
    name: "Turbine UI",
    icon: TurbineUI,
  },
  {
    name: "PHP",
    icon: PHP,
  },
  {
    name: "Jest",
    icon: Jest,
  },
]
